export const DEFAULT_TEXTAREA_HEIGHT = 20
export const MAX_REPLY_LINES = 6
export const MAX_TEXTAREA_HEIGHT = DEFAULT_TEXTAREA_HEIGHT * MAX_REPLY_LINES
export const MAX_TEXTAREA_LENGTH = 5000
